<template>
  <v-menu top left offset-y nudge-top="5">
    <template #activator="{ attrs, on, value }">
      <slot name="activator" :attrs="attrs" :on="{ ...on }" :run="emitRun"
        ><tcn-au-btn
          class="pr-0"
          :color="color"
          :normal="!small"
          :large="large"
          @click="emitRun"
        >
          <v-tooltip bottom :disabled="!tooltip || value" nudge-bottom="5">
            <template #activator="{ on: tooltip }">
              <span
                v-on="tooltip"
                class="px-2"
                :class="`${whiteText ? 'white' : 'black'}--text`"
                ><slot></slot></span
            ></template>
            <span v-if="model">{{
              typeof model == "object"
                ? typeof itemText == "string"
                  ? model[itemText]
                  : itemText(model)
                : model
            }}</span>
          </v-tooltip>
          <v-divider vertical class="my-1" :dark="whiteText"></v-divider>
          <v-btn
            icon
            v-bind="attrs"
            v-on.stop="on"
            :small="small"
            :large="large"
            :dark="whiteText"
          >
            <v-icon class="toggle-menu" :class="{ rotate: value }"
              >mdi-chevron-down</v-icon
            >
          </v-btn>
        </tcn-au-btn>
      </slot>
    </template>

    <v-list dense flat>
      <v-list-item-group
        v-if="items && items.length"
        v-model="model"
        mandatory
        color="primary"
      >
        <v-list-item
          class="pr-1"
          v-for="(val, i) in items"
          :key="i"
          :value="val"
          @click="emitChange"
        >
          <v-list-item-content>
            <v-list-item-title>{{
              typeof val == "object"
                ? typeof itemText == "string"
                  ? val[itemText]
                  : itemText(val)
                : val
            }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon class="mx-1">
            <v-icon
              v-if="
                typeof val === 'object'
                  ? val[itemValue] === model[itemValue]
                  : val === model
              "
              color="primary"
              small
              >mdi-check</v-icon
            >
          </v-list-item-icon>
        </v-list-item>
      </v-list-item-group>
      <v-list-item v-else>
        <v-list-item-content>
          <v-list-item-title>{{ $t("noItemText") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "TcnDropdownBtn",
  props: {
    value: [Object, String],
    normal: Boolean,
    large: Boolean,
    small: Boolean,
    color: {
      type: String,
      default: "primary",
    },
    whiteText: {
      type: Boolean,
      default: true,
    },
    items: Array,
    itemText: {
      type: [String, Function],
      default: "name",
    },
    itemValue: {
      type: String,
      default: "id",
    },
    tooltip: Boolean,
  },
  data() {
    return {
      selectedValue: null,
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    emitRun() {
      if (this.value) {
        this.$emit("click", this.value);
      }
    },
    async emitChange() {
      await this.$nextTick();
      if (this.value) {
        this.$emit("change", this.value);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.toggle-menu {
  transition: transform 0.3s ease-in-out !important;
}

.toggle-menu.rotate {
  transform: rotate(180deg);
}
</style>

<i18n lang="i18n">
{
  "en": {
    "noItemText": "Empty list"
  },
  "pl": {
    "noItemText": "Pusta lista"
  }
}
</i18n>
